module.exports = __webpack_public_path__ + "img/Screenshot 2566-07-26 at 15.12.48@2x.cc90a392.png";